import { render, staticRenderFns } from "./ProjectDashboardV3.vue?vue&type=template&id=20fe1b38"
import script from "./ProjectDashboardV3.vue?vue&type=script&lang=js"
export * from "./ProjectDashboardV3.vue?vue&type=script&lang=js"
import style0 from "./ProjectDashboardV3.vue?vue&type=style&index=0&id=20fe1b38&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports